import { render, staticRenderFns } from "./HistoriaS.vue?vue&type=template&id=def13ea0"
import script from "./HistoriaS.vue?vue&type=script&lang=js"
export * from "./HistoriaS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports